/*
 * http://jaliyaudagedara.blogspot.in/2016/05/angularjs-download-files-by-sending.html
 *
 * File download as CSV from ajax response
 * @param {Object} data - ajax response object
 * @param {String} filename - download file name 
 */
import c from "Vue/Core/constants.js";
import Loading from "onblick_ui_component_library/src/Components/Spinner/service.js";

var ajaxCSVDownload = function (data, filename) {
  var contentType = 'application/octet-stream';

  var linkElement = document.createElement('a');
  try {
    var blob = new Blob([data], {
      type: contentType
    });
    var url = window.URL.createObjectURL(blob);

    linkElement.setAttribute('href', url);
    linkElement.setAttribute("download", filename);

    var clickEvent = new MouseEvent("click", {
      "view": window,
      "bubbles": true,
      "cancelable": false
    });
    linkElement.dispatchEvent(clickEvent);
  } catch (ex) {
    console.log(ex);
  }

  //document.body.appendChild(linkElement); // FF
  //linkElement.click();
  //document.body.removeChild(linkElement); // FF
}



var getFilePreviewLink = (url) => {

  let fileName = URL2FileName(url);

  /* if (_isFileType(fileName, ".doc") || _isFileType(fileName, ".docx") || _isFileType(fileName, ".xls") || _isFileType(fileName, ".xlsx")) {
     url = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(url)}`;
   } else if (_isFileType(fileName, ".pdf")) {
     url = `https://docs.google.com/gview?url=${encodeURIComponent(url)}&embedded=true`;
   }*/

  return url;

  function _isFileType(fileName, type) {
    return fileName.indexOf(type) !== -1;
  }
};

var getFileDownloadLink = (url) => {
  if (url.indexOf('?') != -1) {
    url += '&download=true';
  } else {
    url += '?download=true';
  }
  return url;
};

var URL2FileName = (value) => {
  if (!value) return "";
  value = value.toString();
  if (value.indexOf("https://") !== -1 || value.indexOf("http://") !== -1 || value.indexOf("ftp://") !== -1) {
    // URL
    let split = value.split("/");
    split = split[split.length - 1].split("?");
    return split[0];
  } else {
    return value;
  }
};

var I9URL2FileName = (value) => {
  if (!value || value == '') 
      return ''
  value = value.toString()
  var onblickFileNameConventionLength = 3;//Since all our fileNames are appended with 'obk' at the end
  var timeStampLength = 16;
  if (value.indexOf('https://') !== -1 || value.indexOf('http://') !== -1 || value.indexOf('ftp://') !== -1) {
      var fileUrlArr = value.split('/')
      fileUrlArr = fileUrlArr[fileUrlArr.length - 1].split('?')
      var fileNameWithTimeStampAndExtension = fileUrlArr[0]
      var fileExtension = fileNameWithTimeStampAndExtension.substring(fileNameWithTimeStampAndExtension.lastIndexOf('.'), fileNameWithTimeStampAndExtension.length)
      var fileNameWithTimeStamp = fileNameWithTimeStampAndExtension.substring(0, fileNameWithTimeStampAndExtension.lastIndexOf('.') - onblickFileNameConventionLength)
      var timeStamp = fileNameWithTimeStamp.substring(fileNameWithTimeStamp.length - timeStampLength,fileNameWithTimeStamp.length)
      //var parsedTimeStamp = parseInt(timeStamp)
      var timeStpExcludeUnderScore = timeStamp.slice(1,15);
      var parsedTimeStamp = parseInt(timeStpExcludeUnderScore)
      if(parsedTimeStamp > 0){
         var fileName = fileNameWithTimeStamp.substring(0,fileNameWithTimeStamp.length - timeStampLength)
         value = `${fileName}${fileExtension}`
         return value
      }
      else {
          value = `${fileNameWithTimeStamp}${fileExtension}`
          return value
      }
  } else {
      return value
  }
};

function GenerateFileURL(url) {

  return new Promise((resolve, reject) => {
    Loading({ loadingText: 'Please wait...' }).close();
    resolve(url)});

  // let proxyURL = proxyFileURL(url);

  // Loading({ loadingText: "Please wait..." });

  // return new Promise((resolve, reject) => {
  //   window.ajax.get(proxyURL, {}, res => {
  //     Loading({ loadingText: "Please wait..." }).close();
  //     resolve(proxyFileURL(res.data.Url));
  //   });
  //   // setTimeout(() => {
  //   //     window.ajax.get(proxyURL, {}, (res) => {
  //   //         resolve(proxyFileURL(res.data.Url))
  //   //     });
  //   // }, 300);
  // });
}
function proxyFileURL(url) {
  return url;//.replace(/.*(\/file.*)/, c.APPLICATIONBASEURL + "$1");
}
function previewSingleDoc(doc) {
    GenerateFileURL(doc).then((url) => {
      window.open(url, '_blank') 
  });
  //window.open(utils.getFilePreviewLink(doc),'_blank')
}

function downloadSingleDoc(doc) {
  //let d = doc + "&download=true";
  GenerateFileURL(doc).then((url) => {
      let endUrl = url + "?download=true"
      window.open(endUrl, '_blank') 
  });
}


var IsNullOrEmpty = (value) => {
  if (value && value.toString() != '') {
    return false
  } else {
    return true
  }
};

function findAncestor(el, cls) {
  while ((el = el.parentElement) && !el.classList.contains(cls));
  return el;
}

var FilterExternalLinkURL = (value) => {
	if (!value || value == '') return '';
	value = value.toString();

	var patt = /(http|https):\/\/.*\.(onblick|azurewebsites)\.(com|net)\/home\/externallinkredirect\?link=(.*)/gi;
	return value.replace(patt, function(p1, p2, p3, p4, p5, offset, string) {
		return p5;
	});
};

// Utils wrapper

var Utils = {}

Utils.ajaxCSVDownload = ajaxCSVDownload;
Utils.getFilePreviewLink = getFilePreviewLink;
Utils.getFileDownloadLink = getFileDownloadLink;
Utils.URL2FileName = URL2FileName;
Utils.IsNullOrEmpty = IsNullOrEmpty;

Utils.findAncestor = findAncestor;

Utils.I9URL2FileName = I9URL2FileName;
Utils.GenerateFileURL = GenerateFileURL;
Utils.previewSingleDoc = previewSingleDoc;
Utils.downloadSingleDoc = downloadSingleDoc;
Utils.FilterExternalLinkURL = FilterExternalLinkURL;
window.Utils = Utils;

export default Utils


// WEBPACK FOOTER //
// ./src/components/Core/utils.js